export default __webpack_public_path__ + "static/media/MeterGraph.8fbcaaf5.svg";